export interface CheckLegalEntityFieldUniquenessParams {
  /** The value the user entered. */
  value: string
  /** Existing values of this field across all entities (unique per org). */
  existingValues: string[]
  /**
   * The entity's current value for this field, if editing — it's allowed
   * (excluded from the check) so an unchanged value doesn't read as a duplicate.
   */
  currentValue?: string
}

/**
 * Decides whether a name / external ID is already taken by another entity.
 * Comparison is trimmed + case-insensitive, matching how the org enforces
 * uniqueness. Returns `true` when the value is taken (i.e. NOT unique).
 *
 * Shared by the create and edit flows; edit passes `currentValue` so keeping
 * the entity's own value is allowed.
 */
export class CheckLegalEntityFieldUniquenessUseCase {
  execute = ({
    value,
    existingValues,
    currentValue,
  }: CheckLegalEntityFieldUniquenessParams): boolean => {
    const normalized = value.trim().toLowerCase()

    // Empty is never a duplicate (optional fields; required fields are guarded
    // separately). The entity's own value is allowed when editing.
    if (!normalized || normalized === currentValue?.trim().toLowerCase()) {
      return false
    }

    return existingValues.some(
      (existing) => existing.trim().toLowerCase() === normalized
    )
  }
}
